import Vue from 'vue';
import Vuex from 'vuex';
import { vuexfireMutations } from 'vuexfire';

import auth from './modules/auth';
import config from './modules/config';
import poi from './modules/poi';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: { auth, config, poi },
  state: {
    // used for contribution info toast
    flagContribution: true,
  },
  getters: {
    showToastContribution(state) {
      return state.flagContribution;
    },
  },
  mutations: {
    ...vuexfireMutations,
    FLAG_CONTRIBUTION_OFF(state) {
      if (state.flagContribution) {
        // set to false only if it is true
        state.flagContribution = false;
      }
    },
  },
  actions: {
    setFlagContribution({ commit }) {
      commit('FLAG_CONTRIBUTION_OFF');
    },
  },
});
